import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  history: PropTypes.object.isRequired,
  query: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  className: PropTypes.string,
  autoFocus: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const defaultProps = {
  width: 400,
  autoFocus: true,
};

class SimpleSearchFilter extends React.PureComponent {
  timeout = null;
  state = { value: this.props.query[this.props.name] || "" };

  handleSearch = ({ target }) => {
    const { query, history, name } = this.props;
    const value = target.value;
    this.setState({ value: value });
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      history.replace({ search: query.stringify({ [name]: value, page: 1 }) });
    }, 200);
  };

  render() {
    const { placeholder, name, className = "", width, autoFocus, autocomplete } = this.props;
    const style = { width };
    return (
      <div className={`subnav ${className}`}>
        <div className="subnav-searcher" style={style}>
          <input
            type="search"
            name={name}
            placeholder={placeholder}
            value={this.state.value}
            onChange={this.handleSearch}
            style={style}
            autoFocus={autoFocus}
            autoComplete={autocomplete}
          />
        </div>
      </div>
    );
  }
}

SimpleSearchFilter.propTypes = propTypes;
SimpleSearchFilter.defaultProps = defaultProps;
export default SimpleSearchFilter;



// WEBPACK FOOTER //
// ./src/partialComponents/SimpleSearchFilter.jsx